import * as apis from "@/apis/from-security-to-set";

export default {
    sendCodeFVS(context, params) {
        return apis.sendCodeFVS(params);
    },
    verifyCodeFVS(context, params) {
        return apis.verifyCodeFVS(params);
    },
    verifyQaFVS(context, params) {
        return apis.verifyQa(params);
    },
    sendCodeFSS(context, params) {
        return apis.sendCodeFSS(params);
    },
    setSecurityFSTS(context, params) {
        return apis.setSecurity(params);
    }
};
